import { request } from '@/tools/index.js'
import Vue from 'vue'
import { Base64 } from '@/tools'
export default {
  getQuestionnaire({ commit }, param) {
    return new Promise((resolve,reject) => {
      Vue.prototype.ssdpRequestDtgw1({
        code: 'survey_queryQuestionnaireInfo',
        headers: {
          's-crc-tpl-code': 'EMAP_FILE_UPLOAD'
        },
        data: param,
      }).then((res) => {
        let { data: {
          RESPONSE: { RETURN_DATA,RETURN_CODE,RETURN_DESC},
        } } = res
        if (!['S000A000', 'S0A00000', 'S1A00000'].includes(RETURN_CODE)) {
          new Vue.prototype.$Dialog({
            title: '温馨提示',
            text: typeof RETURN_DESC === 'string' ? RETURN_DESC : RETURN_DESC.RETURN_DESC,
            theme: 'ios',
            onOk() {
              window.close()
              return;
            },
          })
          reject(RETURN_DESC)
        } else {
          let result = RETURN_DATA ? JSON.parse(Base64.decode(RETURN_DATA)) : RETURN_DATA;
          commit('setQuestionnaire', result.questions)
          commit('setPager', result.pager)
          commit('setQuestionnaireData', result)
          resolve(result);
        }
      }).catch(err => {
        if (err instanceof Error) {
          err = err.message.indexOf('timeout') > -1 || err.message.indexOf('Network Error') > -1 || err.message.indexOf("'request' of undefined") > -1 ? '您的网络异常，请重试' : err.message
        }
        err = typeof err === "string" ? err : err.RETURN_DESC;
        new Vue.prototype.$Dialog({
          title: "温馨提示",
          text: err ? err : '请求错误，请重试',
          theme: "ios",
          isConfirm: false
        });
      });
    })
    // try {
    //   let { data: {
    //     RESPONSE: { RETURN_DATA },
    //   } } = await Vue.prototype.ssdpRequestDtgw1({
    //     code: 'survey_queryQuestionnaireInfo',
    //     headers: {
    //       's-crc-tpl-code': 'EMAP_FILE_UPLOAD',
    //     },
    //     data: param,
    //   })
    //   const res = RETURN_DATA ? JSON.parse(Base64.decode(RETURN_DATA)) : RETURN_DATA
    //   // const res = await request('getQuestionnaire', param)
    //   // let res = surveyDetail
    //   commit('setQuestionnaire', res.questions)
    //   commit('setPager', res.pager)
    //   commit('setQuestionnaireData', res)
    //   return res
    // } catch(err){
    //   if (err instanceof Error) {
    //     err = err.message.indexOf('timeout') > -1 || err.message.indexOf('Network Error') > -1 || err.message.indexOf("'request' of undefined") > -1 ? '您的网络异常，请重试' : err.message
    //   }
    //   err = typeof err === "string" ? err : err.RETURN_DESC;
    //   new Vue.prototype.$RunDialog({
    //     title: "温馨提示",
    //     content: err ? err : '请求错误，请重试',
    //     theme: "ios",
    //     isConfirm: false
    //   });
    // }
  },
  pushPreviewData({ commit }, res) {
    commit('setQuestionnaire', res.questions || [])
    commit('setPager', res.pager)
    commit('setQuestionnaireData', res)
  },
  async getColorOption({ commit }, params) {
    console.log("colorOption: ", params)
    const res = await request('getColorOption', params)
    commit('setColorOption', res)
  }
}
